import dayjs from 'dayjs';
import { keepTwoOrLine, keepTwoOrNull } from '@/utils/utils';
import type { EnergyResilienceAnalysisDetailResponse, EnergyResilienceAnalysisTrendResponse } from './types';

export const buildTrendOption = (
  trend?: EnergyResilienceAnalysisTrendResponse,
  detail?: EnergyResilienceAnalysisDetailResponse
) => {
  const points = trend?.points ?? [];
  const times = points.map(item => (item.ts === undefined ? '' : dayjs(item.ts).format('MM-DD HH:mm')));
  const data = points.map(item => keepTwoOrNull(item.loadRate));
  const avg = detail?.avgLoadRate;

  return {
    grid: {
      left: 40,
      right: 40,
      bottom: 45,
      containLabel: true,
    },
    color: ['#16DD8E'],
    tooltip: {
      trigger: 'axis',
      formatter: (params: any[]) => {
        const point = params?.[0];
        return `${point?.axisValue ?? '--'}<br/>负载率：${keepTwoOrLine(point?.data)}%`;
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: times,
    },
    yAxis: {
      type: 'value',
      nameGap: 20,
      name: '负载率(%)',
    },
    dataZoom: [
      {
        type: 'inside',
        xAxisIndex: 0,
        filterMode: 'none',
      },
      {
        type: 'slider',
        xAxisIndex: 0,
        height: 18,
        bottom: 8,
        filterMode: 'none',
      },
    ],
    series: [
      {
        name: '负载率',
        type: 'line',
        smooth: true,
        showSymbol: false,
        data,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(22, 221, 142, 0.20)' },
              { offset: 1, color: 'rgba(22, 221, 142, 0)' },
            ],
          },
        },
        markLine:
          avg === undefined || avg === null
            ? undefined
            : {
                symbol: 'none',
                label: {
                  show: true,
                  color: '#FFCB47',
                  position: 'insideEndTop',
                  formatter: `平均负载率: ${keepTwoOrLine(avg)}%`,
                },
                lineStyle: { color: '#FFCB47', type: 'dashed' },
                data: [{ yAxis: avg }],
              },
      },
    ],
  };
};
